import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { Container, Card, CardBody } from "reactstrap";
import ModalAws from "../ModalAws";
import config from "../../constants/settings";
import BreadcrumbLink from "../../components/Common/BreadcrumbLink";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";
import { orgId } from "../../constants/utils";
import traccarTokens from '../../helpers/configuration/traccar_tokens.json';

const ServicesMap = (props) => {
  document.title = `${i18n.t("ControlTower")} - ${orgId}`;

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);
  const [infoUser, setInfoUser] = useState({ permissions: [] });
  const [traccarToken, setTraccarToken] = useState(config.services.tokenTraccar);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data);
      
      const partnerId = data.data.partner_id;

      const bmwStaging = ['4013'];
      const bmwProduction = ['4358'];
      const syscomAzcapotzalcoStaging = ['4364'];
      const syscomAzcapotzalcoProduction = ['4364'];
      const syscomIztapalapaStaging = ['7074'];
      const syscomIztapalapaProduction = ['7074'];
      const honeywellStaging = ['10000'];
      const honeywellProduction = ['10000'];
      const reformaStaging = ['7784'];
      const reformaProduction = ['7784'];
      const mabeStaging = ['5313'];
      const mabeProduction = ['5313'];
      const smrStaging = ['4368'];
      const smrProduction = ['4368'];
      const barillaStaging = ['5295'];
      const barillaProduction = ['5295'];
      const indusPapeleraStaging = ['5303'];
      const indusPapeleraProduction = ['5311'];
      const empaquesStaging = ['5311'];
      const empaquesProduction = ['5303'];
      const abbStaging = ['4363'];
      const abbProduction = ['4363'];
      const utepStaging = ['5110'];
      const utepProduction = ['5110'];
      const inbursaPalmasStaging = ['5310'];
      const inbursaPalmasProduction = ['5310'];
      const henkelStaging = ['4356'];
      const henkelProduction = ['4356'];
      const oxxoStaging = ['5315'];
      const oxxoProduction = ['5315'];
      const lapiStaging = ['4362'];
      const lapiProduction = ['4362'];
      const inbursaStaging = ['4355'];
      const inbursaProduction = ['4355'];
      const sigmaStaging = ['7708'];
      const sigmaProduction = ['7708'];
      const eclaStaging = ['5300'];
      const eclaProduction = ['5300'];
      const specEclaStaging = ['4661'];
      const specEclaProduction = ['4661'];
      const mccormickStaging = ['4365'];
      const mccormickProduction = ['4365'];
      
      let selectedToken = config.services.tokenTraccar;
      
      if (bmwStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.BMW;
      } 
      else if (bmwProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.BMW;
      } 
      else if (syscomAzcapotzalcoStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.SYSCOM_AZCAPOTZALCO;
      } 
      else if (syscomAzcapotzalcoProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.SYSCOM_AZCAPOTZALCO;
      }
      else if (syscomIztapalapaStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.SYSCOM_IZTAPALAPA;
      }
      else if (syscomIztapalapaProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.SYSCOM_IZTAPALAPA;
      }
      else if (honeywellStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.HONEYWELL;
      }
      else if (honeywellProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.HONEYWELL;
      }
      else if (reformaStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.REFORMA;
      }
      else if (reformaProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.REFORMA;
      }
      else if (mabeStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.MABE;
      }
      else if (mabeProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.MABE;
      }
      else if (smrStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.SMR;
      }
      else if (smrProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.SMR;
      }
      else if (barillaStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.BARILLA;
      }
      else if (barillaProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.BARILLA;
      }
      else if (indusPapeleraStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.INDUSTRIAL_PAPELERA;
      }
      else if (indusPapeleraProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.INDUSTRIAL_PAPELERA;
      }
      else if (empaquesStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.EMPAQUES_ENVOLTURAS;
      }
      else if (empaquesProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.EMPAQUES_ENVOLTURAS;
      }
      else if (abbStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.ABB;
      }
      else if (abbProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.ABB;
      }
      else if (utepStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.UTEP;
      }
      else if (utepProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.UTEP;
      }
      else if (inbursaPalmasStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.INBURSA_PALMAS;
      }
      else if (inbursaPalmasProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.INBURSA_PALMAS;
      }
      else if (henkelStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.HENKEL;
      }
      else if (henkelProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.HENKEL;
      }
      else if (oxxoStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.OXXO;
      }
      else if (oxxoProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.OXXO;
      }
      else if (lapiStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.LAPI;
      }
      else if (lapiProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.LAPI;
      }
      else if (inbursaStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.INBURSA;
      }
      else if (inbursaProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.INBURSA;
      }
      else if (sigmaStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.SIGMA;
      }
      else if (sigmaProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.SIGMA;
      }
      else if (eclaStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.ECLA;
      }
      else if (eclaProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.ECLA;
      }
      else if (specEclaStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.ESPECIALES_ECLA;
      }
      else if (specEclaProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.ESPECIALES_ECLA;
      }
      else if (mccormickStaging.includes(partnerId)) {
        selectedToken = traccarTokens.staging.MCCORMICK;
      }
      else if (mccormickProduction.includes(partnerId)) {
        selectedToken = traccarTokens.production.MCCORMICK;
      }

      setTraccarToken(selectedToken);
    }
  }, [data, loading]);

  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadcrumbLink title={props.t("ControlTower")} link='/control-tower/services-map' breadcrumbItem={props.t("ControlTower")} />
          {/* <ModalAws /> */}
          <Card>
            <CardBody>
              <iframe 
                src={`${config.services.domainTraccar}/?token=${traccarToken}`} 
                width="100%" 
                height={700} 
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </Fragment>
  );
};

ServicesMap.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(ServicesMap);
